export const initialFormState = {
    id: '',
    name: {
        az: '',
        en: '',
        ru: ''
    }
};
